module.exports = __webpack_public_path__ + "img/god-ape-evil.92238991.png";